/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Nurse from './nurse';
import NurseDetail from './nurse-detail';
import NurseUpdate from './nurse-update';
import NurseDeleteDialog from './nurse-delete-dialog';

const NurseRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Nurse />} />
    <Route path="new" element={<NurseUpdate />} />
    <Route path=":id">
      <Route index element={<NurseDetail />} />
      <Route path="edit" element={<NurseUpdate />} />
      <Route path="delete" element={<NurseDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NurseRoutes;
